import { watch, toValue } from "vue";
const PLAYHEAD_VAR = "--current-time";
// Index of the segment whose [start, end] range contains `time`, or -1 if none.
// Binary search; assumes segments sorted by start and non-overlapping.
export const findActiveSegmentIndex = (segments, time) => {
    let low = 0;
    let high = segments.length - 1;
    let candidate = -1;
    while (low <= high) {
        const mid = (low + high) >> 1;
        if (segments[mid].start <= time) {
            candidate = mid;
            low = mid + 1;
        }
        else {
            high = mid - 1;
        }
    }
    if (candidate < 0)
        return -1;
    return time <= segments[candidate].end ? candidate : -1;
};
// Parks the live --current-time on the active segment's element so the per-word
// highlight CSS restyles one segment (~tens of words) per frame instead of the whole
// transcript. Writing via setProperty — not a template binding — keeps the 60Hz value
// out of every render function, so no transcript component re-renders per frame. The
// element is resolved by data-segment-id only when the active segment changes (a few
// times a minute), not per frame.
export const useTranscriptPlayhead = (options) => {
    const { currentTime, segments, container } = options;
    let activeEl = null;
    let activeId = null;
    watch([() => toValue(currentTime), () => toValue(segments)], ([time, list]) => {
        const index = findActiveSegmentIndex(list, time);
        const nextId = index < 0 ? null : list[index].id;
        if (nextId !== activeId) {
            activeEl?.style.removeProperty(PLAYHEAD_VAR);
            activeId = nextId;
            activeEl = null;
        }
        // Resolve lazily — when the active segment just changed, or if a prior resolve
        // missed because the element had not mounted yet.
        if (activeId !== null && !activeEl) {
            activeEl = container.value?.querySelector(`[data-segment-id="${activeId}"]`) ?? null;
        }
        activeEl?.style.setProperty(PLAYHEAD_VAR, String(time));
    }, { immediate: true });
};
